import { render, staticRenderFns } from "./ExportProducts.vue?vue&type=template&id=10c70cad&scoped=true&"
import script from "./ExportProducts.vue?vue&type=script&lang=ts&"
export * from "./ExportProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c70cad",
  null
  
)

export default component.exports